import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Transition, StateService, RawParams } from '@uirouter/angular';
import * as moment from 'moment';
import { UserPreferenceService } from '../user-preference/user-preference.service';
import { GetShowResponse } from '../FMAPI/get-show-response';
import { Channel } from '../FMAPI/channel';
import { Show } from '../FMAPI/show';

@Component({
  selector: 'app-show-master-detail',
  templateUrl: './show-master-detail.component.html',
  styleUrls: ['./show-master-detail.component.css']
})
export class ShowMasterDetailComponent implements OnInit {

  constructor(
    private transition: Transition,
    private state: StateService,
    private userPrefSvc: UserPreferenceService
  ) { }

  @Input() GetShowResponse: GetShowResponse;

  ShowDate: string;
  FilterPast: boolean;

  ngOnInit() {
    this.GetShowResponse.Schedules.forEach(show => {
      show.ShowTime = moment(show.ShowTime).toDate();
      show.Until = moment(show.Until).toDate();
    });

    this.ShowDate = !!this.transition.params().showdate
      ? this.transition.params().showdate
      : moment({ hour: 0 }).format('YYYY-MM-DD');

    this.FilterPast = !!this.userPrefSvc.Get().FilterPast;
  }

  ShouldBeVisible(show: Show) {
    let now = moment().toDate();
    let isVisible = this.FilterPast == false
      || this.FilterPast == true && show.Until > now;
    return isVisible;
  }

  RefreshDetail() {
    let params: RawParams = {};
    params.chcode = this.GetShowResponse.Channels[0].Code;

    let todayStr = moment().format("YYYY-MM-DD");

    if (this.ShowDate != todayStr) {
      params.showdate = this.ShowDate;

      if (this.ShowDate < todayStr) {
        this.FilterPast = false;
      }
    }

    this.state.go("show.masterdetail", params, { inherit: false });
  }

  FilterPastChange() {
    let pref = this.userPrefSvc.Get();
    pref.FilterPast = !!this.FilterPast;
    this.userPrefSvc.Set(pref);
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/show-master-detail/show-master-detail.component.ts